export const jobs = [
  {
    id: "fandisentinel",
    company: "F&I Sentinel",
    role: "Lead Software Engineer",
    period: "February 2026 - Present",
    technologies: [
      "Cursor",
      "Bedrock",
      "Applied AI",
      "Agentic Workflows",
      "React",
      "Python",
      "AWS",
      "Azure",
      "C#",
      "TypeScript",
      "CSS",
      "DynamoDB",
      "S3",
      "SQL",
    ],
    capabilities: [
      "Technical Leadership",
      "Team Organization",
      "Engineering Standards",
      "Product Discovery",
      "Customer & Partner Facing",
      "Stakeholder Communication",
    ],
    highlights: [
      "Lead architecture and delivery across an engineering team modernizing a legacy platform into cloud-based, event-driven services.",
      "Work with product and business stakeholders to discover workflows, define requirements, and turn operational problems into technical solutions.",
      "Lead AI-assisted document processing and automation initiatives while establishing engineering standards and technical direction across the team.",
    ],
    weight: 1.0,
  },
  {
    id: "amazon",
    company: "Amazon",
    role: "Software Dev Engineer",
    period: "May 2022 - January 2026",
    technologies: [
      "React",
      "Java",
      "AWS",
      "GraphQL",
      "Python",
      "TypeScript",
      "CSS",
      "DynamoDB",
      "S3",
      "SQL",
    ],
    capabilities: [
      "Technical Ownership",
      "Team Organization",
      "Mentorship",
      "Product Discovery",
      "Cross-Functional Collaboration",
    ],
    highlights: [
      "Built internal products used to support employee transfer and operational workflows across Amazon.",
      "Worked with product and business teams to turn ambiguous requirements into technical designs and delivery plans.",
      "Led technical work for the first international expansion of a product while coordinating dependencies across teams.",
    ],
    weight: 0.9,
  },
  {
    id: "transact-campus",
    company: "Transact Campus",
    role: "Software Engineer",
    period: "July 2021 - May 2022",
    technologies: [
      "React",
      "C#",
      "AWS",
      "TypeScript",
      "CSS",
      "DocumentDB",
      "CI/CD",
    ],
    capabilities: [
      "Customer & Partner Facing",
      "Technical Ownership",
      "Cross-Functional Collaboration",
      "Stakeholder Communication",
    ],
    highlights: [
      "Built and supported mobile credential experiences that enabled university IDs in Apple Wallet and Google Wallet.",
      "Worked directly with Apple, Google, internal product teams, and partners on integrations, platform requirements, and delivery.",
      "Helped translate partner capabilities and constraints into product and engineering decisions.",
    ],
    weight: 0.7,
  },
  {
    id: "management-controls",
    company: "Management Controls Inc.",
    role: "Full Stack / Lead UI Engineer",
    period: "September 2020 - July 2021",
    technologies: [
      "Angular",
      "C#",
      "Azure",
      "CSS",
      "SQL",
      "CI/CD",
    ],
    capabilities: [
      "Technical Leadership",
      "Team Organization",
      "Engineering Standards",
      "Cross-Functional Collaboration",
    ],
    highlights: [
      "Led frontend development for a greenfield product and established the initial UI architecture and implementation patterns.",
      "Coordinated development across local and offshore engineers while maintaining consistency across the frontend codebase.",
      "Worked with product and business stakeholders to turn workflow requirements into usable product experiences.",
    ],
    weight: 0.6,
  },
  {
    id: "alaska-airlines",
    company: "Alaska Airlines",
    role: "E-Commerce Software Development",
    period: "December 2018 - August 2020",
    technologies: [
      "React",
      "C#",
      "Python",
      "Azure",
      "TypeScript",
      "CSS",
      "DocumentDB",
      "SQL",
      "CI/CD",
    ],
    capabilities: [
      "Product Discovery",
      "Cross-Functional Collaboration",
      "Stakeholder Communication",
    ],
    highlights: [
      "Built customer-facing web experiences across Alaska Airlines' ecommerce platform.",
      "Worked on a cross-functional initiative that moved mileage accrual from nightly batch processing toward real-time event-driven processing.",
      "Collaborated across engineering, product, and business teams on customer-facing and operational systems.",
    ],
    weight: 0.8,
  },
];
